const Layout = () => import('Views/Layout/ContentLayout')
const Home = () => import('Views/Home/Home')
const Account = () => import('Views/User/Account')
const Login = () => import('Views/User/Login')
const Register = () => import('Views/User/Register')
const Profile = () => import('Views/User/Profile')
const EVoucherList = () => import('Views/EVoucher/EVoucherList')
const EVoucherIssueQueueList = () => import('Views/EVoucher/EVoucherIssueQueueList')
const ConfirmUsedVoucher = () => import('Views/EVoucher/ConfirmUsedVoucher')
const NotFound = () => import('Views/Errors/404')
const ForgotPassword = () => import('Views/User/ForgotPassword')
const ResetPassword = () => import('Views/User/ResetPassword')
const EVoucherManagement = () => import('Views/EVoucher/EVoucherManagement')
const MyVoucher = () => import('Views/EVoucher/MyVoucherList')
const ActivatedEmail = () => import('Views/User/ActivatedEmail')
const HistoryVoucher = () => import('Views/EVoucher/HistoryVoucher')
const ChangePassword = () => import('Views/User/ChangePassword')
const Dashboard = () => import('Views/Dashboard/Dashboard')
const Introduction = () => import('Views/Home/Introduction')
const LookUpVoucher = () => import('Views/EVoucher/LookUpVoucher')
const MyVoucherList = () => import('Views/EVoucher/MyVoucherList')
const GuideLookUpVoucher = () => import('Views/EVoucher/GuideLineLookUpVoucher')
const HelpLookUp = () => import('Views/EVoucher/HelpLookUp')
const HelpRegistration = () => import('Views/EVoucher/HelpRegistration')
const HelpUseVoucher = () => import('Views/EVoucher/HelpUseVoucher')
const EVouchersView = () => import('Views/EVoucher/EVouchersView')
const EVouchersInfoCode = () => import('Views/EVoucher/EVouchersInfoCode')
export default [
  {
    path: '/',
    component: Layout,
    redirect: '/introduction',
    children: [

      // Old
      {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
          requiresAuth: true,
        },
      },

      // Start New
      {
        path: '/introduction',
        name: 'Introduction',
        component: Introduction
      },
      {
        path: '/e-voucher-list',
        component: EVoucherList,
        name: 'E Voucher list'
      },
      {
        path: '/e-voucher-issue-queue-list',
        component: EVoucherIssueQueueList,
        name: 'E Voucher issue queue list',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/e-voucher-management',
        component: EVoucherManagement,
        name: 'E Voucher Management',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/my-vouchers',
        component: MyVoucher,
        name: 'My Voucher',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/history-voucher/:id',
        component: HistoryVoucher,
        name: 'historyVoucher'
      },
      // {
      //   path: '/look-up-voucher',
      //   component: LookUpVoucher,
      //   name: 'lookUpVoucher'
      // },
      {
        path: '/dashboard',
        component: Dashboard,
        name: 'Dashboard',
        children: [
          {
            path: '/useraccount',
            component: Account,
            name: 'account',
            children: [
              {
                path: '/login',
                component: Login,
                name: 'login'
              },
              {
                path: '/register',
                component: Register,
                name: 'register'
              },
              {
                path: '/forgot-password',
                component: ForgotPassword,
                name: 'ForgotPassword'
              }
            ]
          },
          {
            path: '/look-up-voucher',
            component: LookUpVoucher,
            name: 'LookUpVoucher'
          },
          {
            path: '/my-voucher',
            component: MyVoucherList,
            name: 'MyVoucher',
            meta: {
              requiresAuth: true,
            }
          },
          {
            path: '/guide-look-up-voucher',
            component: GuideLookUpVoucher,
            name: 'GuideLookUpVoucher'
          },
          {
            path: '/guide-lookup',
            component: HelpLookUp,
            name: 'HelpLookUp'
          },
          {
            path: '/guide-registration',
            component: HelpRegistration,
            name: 'HelpRegistration'
          },
          {
            path: '/guide-usage',
            component: HelpUseVoucher,
            name: 'HelpUseVoucher'
          },
          {
            path: '/change-password',
            component: ChangePassword,
            name: 'ChangePassword'
          },
          {
            path: '/profile',
            component: Profile,
            name: 'Profile',
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: '/confirm/reset/password/:uid/:token',
            component: ResetPassword,
            name: 'ResetPassword'
          }
        ]
      }
    ]
  },
  {
    path: '/confirm_used_voucher',
    component: ConfirmUsedVoucher,
    name: 'Confirm used voucher'
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '/account/email_activated/:uid/:token',
    component: ActivatedEmail,
    name: 'activatedEmail'
  },
  {
    path: '/viewsdetail/:id/:serial/',
    component: EVouchersInfoCode,
    name: 'viewsDetail'
  },
  {
    path: '/viewslist/:code',
    component: EVouchersView,
    name: 'VouchersView'
  }
]